/**
 * Textfeld ↔ gemeinsamer Text (#305). Ein `<textarea>` meldet nur den neuen
 * Wert, keine Operation; daraus wird hier die eine zusammenhängende Änderung,
 * die eine Eingabe tatsächlich ist. Der Cursor nach der Eingabe entscheidet,
 * wo sie lag — sonst wäre „aa" → „aaa" nicht eindeutig.
 */
export interface Aenderung {
  index: number;
  loeschen: number;
  einfuegen: string;
}

export function eingabeAlsAenderung(alt: string, neu: string, cursorNachher: number): Aenderung | null {
  if (alt === neu) return null;
  // Hinter dem Cursor ist nach einer Eingabe nichts verändert.
  const maxSuffix = Math.min(neu.length - cursorNachher, alt.length);
  let suffix = 0;
  while (suffix < maxSuffix && alt[alt.length - 1 - suffix] === neu[neu.length - 1 - suffix]) suffix++;
  const maxPrefix = Math.min(alt.length - suffix, neu.length - suffix);
  let prefix = 0;
  while (prefix < maxPrefix && alt[prefix] === neu[prefix]) prefix++;
  return {
    index: prefix,
    loeschen: alt.length - suffix - prefix,
    einfuegen: neu.slice(prefix, neu.length - suffix),
  };
}

/** Eine Yjs-Delta-Folge (retain/insert/delete) — nur was hier gebraucht wird. */
export type Delta = Array<{ retain?: number; insert?: unknown; delete?: number }>;

/**
 * Wohin rückt eine Position im eigenen Feld, wenn jemand anderes ändert?
 * Gerechnet in Koordinaten des alten Textes. Eine Einfügung genau an der
 * Position landet vor dem Cursor; ein Löschen, das über die Position reicht,
 * zieht ihn an den Anfang des gelöschten Bereichs.
 */
export function verschiebe(index: number, delta: Delta): number {
  let pos = 0;
  let neu = index;
  for (const op of delta) {
    if (pos > index) break;
    if (op.retain !== undefined) {
      pos += op.retain;
    } else if (op.insert !== undefined) {
      neu += typeof op.insert === "string" ? op.insert.length : 1;
    } else if (op.delete !== undefined) {
      const ende = pos + op.delete;
      neu -= ende <= index ? op.delete : index - pos;
      pos = ende;
    }
  }
  return Math.max(0, neu);
}
